import { FC } from "react";

interface IStepItem {
  isActive: boolean;
  logoUrl?: string;
}
const StepItem: FC<IStepItem> = ({ isActive, logoUrl }) => {
  return (
    <div
      className={`${
        isActive
          ? "bg-[#309760] border-[#E8F8CCE8]"
          : "bg-[#D9D9D9] border-[#CBCBCB]"
      } w-20 h-20 rounded-full border-[5px] border-solid flex justify-center items-center`}
    >
      <img src={logoUrl} width={40} height={40} />
    </div>
  );
};
export default StepItem;
